module.exports = __webpack_public_path__ + "img/ES-J-10.23c621e8.svg";